import React from 'react'
import { TextStyle } from 'react-native'

import Text, { Props as TextProps } from '@common/components/Text'
import { openInTab } from '@web/extension-services/background/webapi/tab'

import { parseTextLinks } from './helpers'
import { ParsedTextLink } from './types'

interface Props extends Omit<TextProps, 'children'> {
  text: string
  linkAppearance: TextProps['appearance']
  /** Rendered inline before the text, e.g. the capitalized type label. */
  prefix?: React.ReactNode
}

const LINK_STYLE = { textDecorationLine: 'underline', cursor: 'pointer' } as TextStyle

/**
 * Renders a toast line, turning `[label](url)` (whitelisted domains only) and
 * the phrase "contact support" into pressable links. Shared by the title and
 * the description so both get the same treatment.
 */
const ToastText = ({ text, linkAppearance, prefix, ...textProps }: Props) => (
  <Text selectable {...textProps}>
    {prefix}
    {parseTextLinks(text).map((element: string | ParsedTextLink) => {
      if (typeof element === 'string') return element

      return (
        <Text
          key={`link-${element.index}`}
          appearance={linkAppearance}
          fontSize={textProps.fontSize}
          weight={textProps.weight}
          style={LINK_STYLE}
          onPress={async () => {
            await openInTab({ url: element.url })
          }}
        >
          {element.text}
        </Text>
      )
    })}
  </Text>
)

export default ToastText
